// Helper partajat pentru destinația unei notificări când user-ul dă click.
// Folosit în NotificationBell (popover) și Dashboard (activitate recentă).
export const getNotificationRoute = (notif) => {
  if (!notif?.type) return '/notifications';

  if (notif.type === 'SIGNATURE_TURN') {
    // Raport ITM — rutare la tab-ul ITM al firmei
    if (notif.data?.context === 'ITM' && notif.data?.companyId) {
      return `/companies/${notif.data.companyId}?tab=itm`;
    }
    return '/sheets-to-sign?pending=true';
  }
  if (notif.type === 'TRAINING_ASSIGNED') return '/my-courses';
  if (notif.type === 'IP_REMINDER') return '/employees?tab=ip-due';
  return '/notifications';
};
